import React from 'react';

function MainTabsMenu(props) {
  const { t, operator } = props;
  return (
    <div
      className="sub-details-section-internal-card font10"
      style={{
        background: '#e6f4fa',
      }}
    >
      {props.menus.map((val, key) => (
        <div
          key={key}
          className={
            'internal-card-item ' +
            (val.active && props.menuType == 'LEFT_MENU' ? 'active' : 'not-active')
          }
          onClick={() => props.onMenuChange(key)}
        >
          <img
            className="icon1"
            src={val.active && props.menuType == 'LEFT_MENU' ? val.iconActive : val.icon}
            alt=""
          />
          {!val.active || props.menuType === 'TOP_MENU' ? (
            <img className="icon2" src={val.iconActive} alt="" />
          ) : null}
          <span className="side-menu-item-label" style={{ color: 'black' }}>
            {t('PROFILE.' + val.name)}
          </span>
        </div>
      ))}
    </div>
  );
}

export default MainTabsMenu;



// WEBPACK FOOTER //
// ./src/features/themes/my-account/MainTabsMenu/MainTabsMenu.js